import { render } from "./barranavegacion.vue?vue&type=template&id=0463e651&scoped=true"
import script from "./barranavegacion.vue?vue&type=script&lang=js"
export * from "./barranavegacion.vue?vue&type=script&lang=js"

import "./barranavegacion.vue?vue&type=style&index=0&id=0463e651&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0463e651"]])

export default __exports__